import { Flex, Box, Image } from "theme-ui";
import { MessageCircle, Award, AlertCircle, Smile } from "react-feather";
import { useTranslation } from "react-i18next";

import { Carousel } from "src/components/atoms";
import { IconMenuOption } from "src/components/molecules";
import { PrinciplesProps } from "./Principles.d";
import shake_hands from "src/assets/images/shaking_hands.svg";
import { extractBaseLang } from "src/utils";

export const Principles: React.FC<PrinciplesProps> = (props) => {
  const { t, i18n } = useTranslation();
  const values: string[] = t("home.values", { returnObjects: true });
  const currentLanguage = extractBaseLang(i18n.language);

  const tabs = [
    {
      icon: () => <Image src={shake_hands} width="38px" />,
      text: values[0],
    },
    {
      icon: () =>
        currentLanguage === "es" ? (
          <MessageCircle size={33} />
        ) : (
          <Smile size={33} />
        ),
      text: values[1],
      colors: ["tertiary", "accent"],
    },
    {
      icon: () => <Award size={33} />,
      text: values[2],
      colors: ["accent", "secondary"],
    },

    {
      icon: () =>
        currentLanguage === "es" ? (
          <AlertCircle size={33} />
        ) : (
          <MessageCircle size={33} />
        ),
      text: values[3],
      colors: ["secondary", "highlight"],
    },
  ];

  return (
    <Flex {...props}>
      <Box sx={{ width: "100%" }}>
        <Carousel
          sizes={["540px", "980px", "100%"]}
          data={tabs}
          spaceBetween={30}
          renderItem={(item, index) => (
            <Box sx={{ height: "150px", mb: 6 }}>
              <IconMenuOption
                key={index}
                active
                text={item.text}
                customIcon={item.icon()}
                colors={item.colors}
              />
            </Box>
          )}
        />
      </Box>
    </Flex>
  );
};
